// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__1NqpW","content":"Page_content__2enuc","scrollingDisabled":"Page_scrollingDisabled__1QdrI"};